import { Text, Button, Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useAtom } from 'jotai';
import { componentModificationWarningAtom } from '~/atoms/no-code-atoms';
import { notifications } from '@mantine/notifications';

export function ComponentModificationWarningCard({ componentId: _ }: { componentId: string }) {
  const [warningState, setWarningState] = useAtom(componentModificationWarningAtom);

  return (
    <div className="@container mx-2 mt-2">
      <Alert
        icon={<IconAlertTriangle size={14} />}
        variant="light"
        color="yellow"
        className="border-[var(--mantine-color-yellow-5)] dark:border-[var(--mantine-color-yellow-8)]"
        classNames={{
          root: 'py-1.5 px-2',
        }}
      >
        <div className="flex flex-col items-end gap-2 @xs:flex-row @xs:items-center @xs:justify-between">
          <div className="flex items-center gap-1">
            <Text
              size="xs"
              fw={500}
            >
              This component may be used in other tests and components. Modifying it will update all instances. Continue
              anyway?
            </Text>
          </div>

          <div className="flex items-center gap-2">
            <Button
              size="compact-xs"
              variant="default"
              onClick={() => setWarningState(undefined)}
            >
              Cancel
            </Button>
            <Button
              size="compact-xs"
              color="yellow"
              onClick={async () => {
                try {
                  await warningState?.onConfirm();
                  setWarningState(undefined);
                } catch (error) {
                  console.error(error);
                  notifications.show({
                    title: 'Error',
                    message: 'Failed to modify component',
                    color: 'red',
                  });
                }
              }}
            >
              Continue
            </Button>
          </div>
        </div>
      </Alert>
    </div>
  );
}
